// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5D2xjenF","description":"_5D1ikh-O","loader":"_5D3wFrgr","sendRequest":"_5DjFe6pq","reports-container":"_5D1It30Y"};